import React, { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { createVideoDetail, resetVideo } from "../store/action";
import {
  CreateVideoError,
  CreateVideoInput,
  VideoDetailProps,
} from "../store/actionType";
import { ApiError } from "components";
import VideoForm from "./components/VideoForm";

interface OwnProps {
  videoData: VideoDetailProps;
  closeModal: () => void;
  episode_id: string | undefined;
  category_id: string | undefined;
  season_folder_id: string | undefined;
}

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;

const HandleCreateVideo: React.FC<Props> = ({
  closeModal,
  videoData,
  onCreateVideo,
  onResetVideo,
  episode_id,
  category_id,
  season_folder_id,
}) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState<CreateVideoInput>({
    title: "",
    episode_id: episode_id,
    category_id: category_id,
    season_folder_id: season_folder_id,
  });
  const [error, setError] = useState<CreateVideoError>({});
  const [apiError, setApiError] = useState<string | null>(null);
  const [submitted, setSubmitted] = useState(false);
  const videoDetailsState = useSelector(
    (state: any) => state.videoDetails?.genericVideoDetailsState
  );

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSave = async (e: FormEvent) => {
    e.preventDefault();

    if (formData.title.trim() === "") {
      setError({ title: "Video title is required" });
      return;
    }

    setError({});
    setLoading(true);

    try {
      const input: CreateVideoInput = {
        title: formData.title,
        episode_id: episode_id?.toString(),
        category_id: category_id?.toString(),
        season_folder_id: season_folder_id?.toString(),
      };
      await onCreateVideo(input);

      setSubmitted(true);
    } catch (err: any) {
      setApiError("Failed to create video metadata");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!videoDetailsState.isLoading && submitted) {
      if (videoDetailsState.error) {
        setApiError(videoDetailsState.error);
      } else {
        setApiError(null);
        closeModal();
      }
    }
  }, [videoDetailsState.isLoading, videoDetailsState.error, submitted]);

  return (
    <>
      <VideoForm
        handleChange={handleChange}
        handleSubmit={handleSave}
        formData={formData}
        videoError={error}
        loading={loading}
        header={"Create Video Detail"}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onCreateVideo: (input: CreateVideoInput) =>
    dispatch(createVideoDetail(input)),
  onResetVideo: () => dispatch(resetVideo()),
});

export default connect(null, mapDispatchToProps)(HandleCreateVideo);
